import React, {useContext, useEffect, useState} from 'react';
import AuthContext from "../../Services/AuthContext";
import StyledModal from "../../Component/StyledModal";
import {InputAdornment, TextField, Typography} from "@mui/material";
import StyledSelect from "../../Component/StyledSelect";


function EditSeason(props) {
    const title = 'Edytuj Sezon';
    const description = 'Tutaj możesz dodać ograniczenie sezonu dla swoich wydarzeń.';

    const [user] = useContext(AuthContext);
    const [name, setName] = useState('');
    const [quota, setQuota] = useState(0);
    const [organization, setOrganization] = useState({id: user.facilities[0]?.id, label: user.facilities[0]?.name});


    useEffect(() => {
        setName(props.data?.name);
        setQuota(props.data?.quota);
    }, [props.data]);
    function _send() {
        const formData = {
            name: name,
            quota: quota,
            organization_id: organization.id
        };
        fetch(`/api/season/${props.data.id}`, {
            method: 'PUT',
            body: JSON.stringify(formData),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(data => {
                props.onSuccess(data);
                props.dismiss();
            })
            .catch(err => { console.log(err) })
    }

    return (<StyledModal isOpen={props.data !== false} title={title} description={description} send={_send} dismiss={props.dismiss}>
                <Typography variant={'h6'}>{props.data.organization}</Typography>
                <TextField
                    onChange={(e) => setName(e.target.value)}
                    label='Nazwa'
                    value={name}
                    variant="outlined"
                    fullWidth
                />
                <TextField
                    type={'number'}
                    onChange={(e) => setQuota(e.target.value)}
                    label='Blokada'
                    value={quota}
                    variant="outlined"
                    fullWidth
                    slotProps={{
                        input: {
                            endAdornment: <InputAdornment position="end">dni</InputAdornment>,
                        },
                    }}
                />
        </StyledModal>);
}
export default EditSeason;